import React, { useState } from 'react';

import { AsyncInputNumber } from '@partsbadger/library';
import { Form, InputNumber } from 'antd';

interface IProps {
    quantity: number;
    max_quantity: number;
    handleRemove?: () => void;
    handleSave?: (item: { quantity: number; unit_price: number; total_price: number; lead_time: number }) => void;
    editable: boolean;
    hidePrices?: boolean;
    handleChangeQuantity?: (quantity: number) => void;
}

const QuoteQuantityInput: React.FC<IProps> = props => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [updateQuantity, setUpdateQuantity] = useState(props?.quantity);
    const [validateStatus, setValidateStatus] = useState<'success' | 'error'>('success');
    const { quantity, handleRemove, editable, handleChangeQuantity } = props;

    let busy: any = null;

    const submitQuantity = () => {
        if (handleChangeQuantity) {
            handleChangeQuantity(updateQuantity);
        }
    };

    const handleChange = async () => {
        if (busy) {
            clearTimeout(busy);
        }

        if (handleChangeQuantity) {
            busy = setTimeout(submitQuantity, 400);
        }
    };

    return (
        <>
            <div className="flex align-items-center m-2">
                <span className="font-weight-bold mr-2">Quantity:</span>

                {editable ? (
                    <Form.Item
                        validateStatus={validateStatus}
                        help={validateStatus === 'error' && `Select a number between 1 and ${props.max_quantity}`}
                        className="m-0"
                    >
                        <InputNumber
                            min={1}
                            max={props.max_quantity}
                            step={1}
                            controls={false}
                            onBlur={handleChange}
                            onChange={qty => {
                                if (qty) {
                                    setIsLoading(true);

                                    if (qty > props.max_quantity) {
                                        setValidateStatus('error');
                                        return;
                                    }

                                    setValidateStatus('success');

                                    setUpdateQuantity(qty);
                                    setIsLoading(false);
                                } else {
                                    setUpdateQuantity(1);
                                }
                            }}
                            defaultValue={updateQuantity}
                            style={{ width: '70px' }}
                        />
                    </Form.Item>
                ) : (
                    <>
                        <span className={'h-full flex flex-col justify-center'}>{quantity}</span>
                    </>
                )}
            </div>
        </>
    );
};

export default QuoteQuantityInput;
